// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {buildAuditDealerString} from '../../../shared/services/build-audit-dealer-string.js';

const RecordAuditModalHeader = props =>
    <header className='record-audit-modal-header'>
        <FormattedMessage
            id='SUBMIT_AUDIT_FOR'
            values={{dealer: buildAuditDealerString(props.leadAccountName, props.city, props.state)}}
        />
        <span
            className='close-modal-icon'
            onClick={props.onClose}
        />
    </header>;

RecordAuditModalHeader.displayName = 'RecordAuditModalHeader';
RecordAuditModalHeader.propTypes = {
    city: PropTypes.string,
    leadAccountName: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    state: PropTypes.string
};

export default RecordAuditModalHeader;



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/components/record-audit-modal/record-audit-modal-header.js